import type { ContactCenterUserContext as UserContext } from '@ucc/admin-global-state'

import api from 'api'
import { fetchWithToken } from 'utils'

/**
 * Retrieves the Contact Center user context
 */
const fetchUserContext = async (pbxId: string): Promise<UserContext | null> =>
  fetchWithToken({
    method: 'GET',
    resource: api.ccAuthority,
    path: `organizations/${pbxId}/user/context`,
    useV5: false,
    useVersion: 'v1',
  })
    .then((response: Response) => (response.ok ? response.json() : null))
    .catch((err: Error) => {
      // Something wrong happened during the fetch
      console.error(err.toString())
    })

export default fetchUserContext
